module.exports = __webpack_public_path__ + "img/up-arrow.a01da910.svg";